import CheckBox from '@app/components/CheckBox'
import { actionCreators as FeedItemActionCreators } from '@app/components/FeedItem/modules/feedItems'
import FeedItemEditor from '@app/components/FeedItemEditor'
import ItemLeadsList from '@app/components/ItemLeadsList'
import { FeedItemSourceType, FeedItemType } from '@app/models/enums'
import { ICurrentUserState } from '@app/store/modules/account'
import { IGlobalSocialNetworksState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Button, Collapse } from 'reactstrap'
import {
  actionCreators,
  IConnectionViewState,
} from '../modules/connectionView'

interface IConnectionViewRouterProps {
  id: string
}

interface IComponentState {
  includeArchived: boolean
  showQuickAdd: boolean
}

type IComponentProps = IConnectionViewState &
  ICurrentUserState &
  IGlobalSocialNetworksState &
  RouteComponentProps<IConnectionViewRouterProps> &
  typeof actionCreators &
  typeof FeedItemActionCreators

class ConnectionLeads extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  public constructor(props: any) {
    super(props)

    bindFunctions(this)

    this.state = {
      includeArchived: false,
      showQuickAdd: false,
    }
  }

  public render() {
    return (
      <div>
        <div className='d-flex flex-row justify-content-between align-items-center'>
          <div>
            <CheckBox
              value={this.state.includeArchived}
              onChange={this._changeIncludeArchived}
            />
            Include archived
          </div>
          <Button color='link' onClick={this._toggleShowQuickAdd}>
            {this.state.showQuickAdd ? 'Hide quick add' : 'Show quick add'}
          </Button>
        </div>
        <Collapse isOpen={this.state.showQuickAdd}>
          <div className='mb-3'>
            <FeedItemEditor
              contextId={this.props.match.params.id}
              contextType={FeedItemSourceType.Contact}
              itemType={FeedItemType.Lead}
            />
          </div>
        </Collapse>
        <ItemLeadsList
          className='mt-3'
          displayArchivedLeads={this.state.includeArchived}
          leads={this.props.item.leads}
          onArchive={(id) => this.props.archiveLead(id)}
          onClick={(id) => this.props.history.push(`/feed/${id}`)}
        />
      </div>
    )
  }

  private _changeIncludeArchived() {
    this.setState({ includeArchived: !this.state.includeArchived })
  }

  private _toggleShowQuickAdd() {
    this.setState({ showQuickAdd: !this.state.showQuickAdd })
  }
}

export default withRouter(ConnectionLeads)
